export default "__VITE_ASSET__f5f61633__"